import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Login } from '../model/model.login';
import { environment } from 'src/environments/environment';

@Injectable()
export class LoginService {

  basePath = environment.BasePath+"/survey";

  constructor(private httpClient: HttpClient) { }

  getUser(login: string, password: string): Observable<any> {
    return this.httpClient.get(this.basePath + "/login?login=" + login + "&password=" + password)

  }

  saveUser(user: Login): Observable<any> {
    return this.httpClient.post(this.basePath + "/user", user)

  }

  editUser(user: Login): Observable<any>{
    return this.httpClient.put(this.basePath + "/user/"+user.id,user)

  }

  getUserById(id:number): Observable<any>{
    return this.httpClient.get(this.basePath + "/user/"+id)

  }

}
